import { ErrorCard } from '@starsoft/common/components';
import { useMemo } from 'react';
import Coin from './Coin';
import styles from './styles.module.scss';
import { useWalletsMe } from '@/api/wallets';

export default function Coins() {
  const { fiats, error, refetch, isLoading: isPending } = useWalletsMe();
  const Items: JSX.Element[] = useMemo(
    () =>
      fiats?.map(coin => (
        <Coin key={`conversion_coin_${coin?.id}`} coin={coin} />
      )),
    [fiats],
  );
  const Skeletons: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 50 })?.map((_, i) => (
        <Coin
          isLoading
          coin={null}
          key={`fiat_conversion_coin_skeleton_${i}`}
        />
      )),
    [],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <div className={styles.container}>
      {Items}
      {isPending && Skeletons}
    </div>
  );
}
